import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { MAX_ROWS_LIMIT, getRegionMarket } from '@intelligence/components/DownloadCommon/DownloadPage/utils';

// 外部传入数据，转为下载接口所需要参数
const getDownloadApiParams = (params: any) => {
  console.debug('getDownloadApiParams_params', params);

  let pageSize = params.page_size;
  // let pageSize = params?.select_top > 500 ? 500 : params?.select_top;

  const groupByList: any = [];
  if (params?.downlaod_date_method === 'separate') {
    groupByList.push('date');
    // pageSize = MAX_ROWS_LIMIT;
  }
  if (params?.region_method === 'market') {
    groupByList.push('market');
    // pageSize = MAX_ROWS_LIMIT;
  }
  if (params?.region_method === 'region') {
    groupByList.push('region');
    // pageSize = MAX_ROWS_LIMIT;
  }

  if (params?.data_method === 'selectTop') {
    pageSize = params?.select_top;
  } else if (params?.data_method === 'selectAll') {
    pageSize = MAX_ROWS_LIMIT;
  } else if (params?.data_method === 'checkedLines') {
    pageSize = params?.select_ids?.length;
  }
  // pageSize = params?.select_top;

  const paramsValue = {
    ...params?.fp,
    regions: params?.region_method === 'aggregated' ? params?.regions : getRegionMarket(params),
    group_by: groupByList,
    page: 1,
    page_size: pageSize,
    unified_ids: params?.select_ids || [],
    // order_by: ['unified_id asc', 'date desc', 'market asc'],
    // order_by: orderByList,
  };
  // delete paramsValue.regions;
  return paramsValue;
};

const getSummarySheet = () => {
  const list: any[] = [];
  return list;
};

const granularityObject: Record<string, string> = {
  daily: 'D',
  weekly: 'W',
  monthly: 'M',
};

const getFileName = (params: any) => {
  const {
    start_release_time,
    start_date,
    end_release_time,
    end_date,
    granularity,
    new_style_donwload_file_name,
  } = params;
  const gItem = granularityObject[granularity];
  if (start_date && end_date) {
    return `${new_style_donwload_file_name}_${start_date}_${end_date}`;
  }
  if (start_release_time && end_release_time) {
    return `${new_style_donwload_file_name}_Release_${gItem}${start_release_time}_${gItem}${end_release_time}`;
  }
  return `${new_style_donwload_file_name}`;
};

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    isUsingNewMethod: false,
    $$fileName: getFileName(params),
    downloadFetchApi: '/api/v1/intelligence_pc/mobile_topcharts_rpd_list',
    dataKey: undefined,
    summarySheet: getSummarySheet(),
    regionOptions: params?.regionOptions,
    byDate: params?.downlaod_date_method !== 'aggregated',
    granularity: granularityObject[params?.granularity],
    isRelease: !!(params?.end_release_time && params?.start_release_time),
    downloadApiParams: getDownloadApiParams(params),
    downloadMode: 'commonConf',
    downloadConfigKey: 'mobile_topCharts_RPD',
    fetchOnlyOnce: false, // 是否只下载一次
  };
};
